import React, { ReactNode } from 'react'

import { Empty } from 'antd'

interface NoDataProps {
  length?: number
  className?: string
  description?: ReactNode
}

const NoData: React.FC<NoDataProps> = ({ length, className, description }) => {
  if (length) return length === 0 ? <Empty className={className} /> : null
  return <Empty description={description} className={className} />
}

export default NoData
